import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import "./FeedSkeleton.css";
function FeedSkeleton() {
  return (
    <div className="feedskeleton">
      <Skeleton variant="text" width="100%" height="6vh" />
      <Skeleton variant="text" width="100%" height="6vh" />
      <Skeleton variant="text" width="100%" height="6vh" />
      <Skeleton variant="text" width="100%" height="6vh" />
      <Skeleton variant="text" width="100%" height="6vh" />
    </div>
  );
}

export default FeedSkeleton;
